// MARK: NPM Modules
import styled from "styled-components";

// MARK: Styled Components
interface Props {
  margin?: number;
  flexDirection?: string;
  marginBottom?: number;
}

const SectionContainer = styled.section<Props>`
  display: flex;
  flex-direction: ${({ flexDirection }) =>
    flexDirection ? flexDirection : "column"};
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: auto;
  margin-top: ${({ margin }) => (margin ? margin : 0)}px;
  background-color: transparent;
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : 0)}px;
`;

export default SectionContainer;
